import Swal from "sweetalert2";

export const snackbar = (message) => {
  return Swal.fire({
    html: `<div style=" position: relative; width: 100% ; height:100%;">
    <p style="width:100% ; padding-left:50px; text-align:justify; font-size:13px; ">${message}</p></div>`,
    showConfirmButton: false,
    padding: "3px",
    position: "bottom-end",
    background: "#0f172a",
    color: "#e4e4e4",
    backdrop: false,
    showCancelButton: true,
    cancelButtonText: "",
    timer: 12000,
    customClass: {
      cancelButton: " cancelbuttonsnakebar",
      actions: "actionssnakebar",
    },
  });
};
export const snackbar2 = (message) => {
  return Swal.fire({
    html: `<div style=" position: relative; width: 100% ; height:100%;">
    <p style="width:100% ; padding-left:50px; text-align:justify; font-size:13px; ">${message}</p></div>`,
    showConfirmButton: false,
    padding: "3px",
    position: "bottom-end",
    background: "#0f172a",
    color: "#e4e4e4",
    backdrop: false,
    showCancelButton: true,
    cancelButtonText: "",
    timer: 4000,
    customClass: {
      cancelButton: " cancelbuttonsnakebar",
      actions: "actionssnakebar",
    },
  });
};
export const successMessage = (message) => {
  // return Swal.fire({
  //   html: `<div style=" position: relative; width: 100% ; height:100%;  ">
  //   <p style="width:100% ; padding-left:10px;padding-right:10px; text-align:justify; font-size:13px; ">${message}</p>

  //    </div>`,
  //   showConfirmButton: false,
  //   timer: 4500,
  //   timerProgressBar: true,
  //   position: "bottom-end",
  //   background: "#96DBAD",
  //   color: "#000",
  //   backdrop: false,
  // });


  return Swal.fire({
    html: `<div style=" position: relative; width: 100% ; height:100%;">
    <p style="width:100% ; padding-left:50px; text-align:justify; font-size:13px; ">${message}</p></div>`,
    showConfirmButton: false,
    padding: "3px",
    position: "bottom-end",
    background: "#369e39ff",
    color: "#e4e4e4",
    backdrop: false,
    showCancelButton: true,
    cancelButtonText: "",
    timer: 7000,
    customClass: {
      cancelButton: " cancelbuttonsnakebar",
      actions: "actionssnakebar",
    },
  });
};

export const showAlertMessage = (message, confirmButtonText) => {
  return Swal.fire({
    html: message,
    icon: "info",
    color: "#000",
    background: "#fff",
    backdrop: false,
    confirmButtonText: confirmButtonText || "OK",
  });
}
export const loginSuccessMessage = (message) => {
  return Swal.fire({
    html: message,
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    position: "top-end",
    background: "#2be381",
    color: "#000",
    backdrop: false,
    confirmButtonText: "OK",
  });
  // return Swal.fire({
  //   html: message,
  //   showConfirmButton: true,
  //   position: 'center',
  //   imageHeight: 50,
  //   focusConfirm: false,
  //   color: '#000',
  //   background: '#fff',
  //   backdrop: `rgba(36, 27, 2,0.4)`
  // });
};

export const errorMessage = (message) => {
  if (message == "AxiosError: Network Error") {
    message = "Oops! Something went wrong. Please give it another try.";
  }
  return Swal.fire({
    html: `<div style=" position: relative; width: 100% ; height:100%;">
    <p style="width:100% ; padding-left:50px; text-align:justify; font-size:13px; ">${message}</p></div>`,
    showConfirmButton: false,
    padding: "3px",
    position: "bottom-end",
    background: "#0f172a",
    color: "#e4e4e4",
    backdrop: false,
    showCancelButton: true,
    cancelButtonText: "",
    timer: 12000,

    customClass: {
      cancelButton: "cancelbuttonsnakebar",
      actions: "actionssnakebar",
    },
  });

  // Swal.fire({
  //   // html: code ? `${message} (${code})` : `${message}`,
  //   html: `${message}`,
  //   icon: "error",
  //   color: '#000',
  //   background: '#fff',
  //   backdrop: `rgba(36, 27, 2,0.4)`,
  //   confirmButtonText: "OK",
  //   customClass: {
  //     container: 'alertcontainer',
  //     actions: 'alertactions',
  //     title: "alerttitle",
  //     cancelButton: "alertcancelbutton",
  //     confirmButton: "alertconfirmbutton",
  //     denyButton: "alertdenybutton",
  //   },
  // });
};
export const errorMessage2 = (message, code) => {
  if (message == "AxiosError: Network Error") {
    message = "Oops! Something went wrong. Please give it another try.";
  }
  return Swal.fire({
    // html: code ? `${message} (${code})` : `${message}`,
    html: `${message}`,
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    position: "bottom-end",
    background: "#fff",
    color: "#000",
    backdrop: false,
  });
};
export const catchMessage = (error) => {
  // return Swal.fire({
  //   text: "Opps!, an error has occurred",

  //   focusConfirm: false,
  //   color: '#000',
  //   background: '#fff',
  //   backdrop: `rgba(36, 27, 2,0.4)`,
  //   confirmButtonText: "OK"
  // });
  let message = error;
  if (message == "AxiosError: Network Error") {
    message = "Oops! Something went wrong. Please give it another try.";
  }
  return Swal.fire({
    html: `<div style=" position: relative; width: 100% ; height:100%;">
    <p style="width:100% ; padding-left:50px; text-align:justify; font-size:13px; ">${message}</p></div>`,
    showConfirmButton: false,
    padding: "3px",
    position: "bottom-end",
    background: "#0f172a",
    color: "#e4e4e4",
    backdrop: false,
    showCancelButton: true,
    cancelButtonText: "",
    timer: 12000,
    customClass: {
      cancelButton: " cancelbuttonsnakebar",
      actions: "actionssnakebar",
    },
  });
};
export const confirm = async (message, confirmButtonText, denyText) => {
  return Swal.fire({
    title: "",
    icon: "warning",
    html: `<div style=" position: relative; width: 100% ; height:100%;  ">
    <p style="width:100% ; padding-left:10px;padding-right:30px; padding-top:40px;    ">${message}</p>
    
     </div>`,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: confirmButtonText ? confirmButtonText : "YES",
    cancelButtonText: "",
    denyButtonText: denyText ? denyText : "NO",
    showDenyButton: true,
    customClass: {
      container: "alertcontainer",
      actions: "alertactions",
      title: "alerttitle",
      cancelButton: "alertcancelbutton",
      confirmButton: "alertconfirmbutton",
      denyButton: "alertdenybutton",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
  });
};
export const dataErrorsMessage = (dataErrors) => {
  return Swal.fire({
    html: dataErrors,
    confirmButtonText: "OK",
    focusConfirm: false,
    color: "#000",
    background: "#fff",
    backdrop: `rgba(36, 27, 2,0.4)`,
  });
};

export const deleteMessage = async () => {
  return Swal.fire({
    title: "",
    text: "Are You sure? you want to delete?",
    showCloseButton: false,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText: "YES",
    cancelButtonText: "",
    color: "#000",
    background: "#fff",
    backdrop: `rgba(36, 27, 2,0.4)`,
    customClass: {
      container: "alertcontainer",
      actions: "alertactions",
      title: "alerttitle",
      cancelButton: "alertcancelbutton",
      confirmButton: "alertconfirmbutton",
      denyButton: "alertdenybutton",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
  });
};

export const confirmMessage = async (title, message, confirmText, denyText) => {
  return Swal.fire({
    title: title,
    html: `<div style=" position: relative; width: 100% ; height:100%;  ">
    <p style="width:100% ; padding-left:10px;padding-right:30px; padding-top:40px;    ">${message}</p>    
     </div>`,
    showCloseButton: false,
    showCancelButton: true,
    showDenyButton: true,
    focusConfirm: false,
    confirmButtonText: confirmText ? confirmText : "YES",
    denyButtonText: denyText ? denyText : "No",
    cancelButtonText: "",
    color: "#000",
    background: "#fff",
    backdrop: `rgba(36, 27, 2,0.4)`,
    customClass: {
      container: "alertcontainer",
      actions: "alertactions",
      title: "alerttitle",
      cancelButton: "alertcancelbutton",
      confirmButton: "alertconfirmbutton",
      denyButton: "alertdenybutton",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      return true;
    }
  });
};
